// Prototype-only: seed the dev auth bypass + in-browser API mock BEFORE anything
// else evaluates. This file must be the FIRST import in main.tsx so the fake
// session is in localStorage before Routes.tsx creates the router and the route
// guard (protectedLoader) runs — otherwise it redirects to /login on first load.
import { seedDevAuth } from "@/lib/devAuth";

seedDevAuth();
